import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'embeds/components';

const styles = (theme) => {
  const color = theme.custom.palette.colorSupportSlate;
  return {
    root: {
      borderRadius: 100,
    },
    label: {
      textTransform: 'inherit',
      fontWeight: 'bold',
    },
    disabled: {
      color,
    },
    flat: {
      color,
    },
    outlined: {
      color,
    },
    containedPrimary: {
      backgroundColor: color,
    },
  };
};

class TimelineLabel extends React.PureComponent {
  render() {
    const {
      classes: { root, ...otherClasses },
      children,
      className,
      ...other
    } = this.props;
    return (
      <Button
        classes={{
          root: classnames(root, className),
          ...otherClasses,
        }}
        {...other}
      >
        {children}
      </Button>
    );
  }
}

TimelineLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(TimelineLabel);
